import Swal from 'sweetalert2'

export const showRequestError = async (error: any) => {
  if (error?.response?.status === 422) {
    let errorText = ''
    for (let key in error.response.data.errors) {
      errorText += '<li>' + error.response.data.errors[key][0] + '</li>'
    }
    await Swal.fire({
      icon: 'error',
      title: 'Ops! Revise seu formulário e tente novamente!',
      html: errorText,
    })
    return
  }

  await Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: error?.response?.data?.message,
    timer: 2000,
  })
}
